import React from 'react';
import PropTypes from 'prop-types';

const JsonPreview = ({ data }) => {
  const renderJson = (data, level = 0) => {
    const indent = { marginLeft: `${level * 20}px` };

    if (Array.isArray(data)) {
      return (
        <div style={indent} className="font-mono">
          [
          {data.map((item, index) => (
            <div key={index} style={{ marginLeft: '20px' }}>
              {renderJson(item, 0)}
              {index < data.length - 1 && ','}
            </div>
          ))}
          ]
        </div>
      );
    }

    if (typeof data === 'object' && data !== null) {
      return (
        <div style={indent} className="font-mono">
          {'{'}
          {Object.entries(data).map(([key, value], index) => (
            <div key={index} style={{ marginLeft: '20px' }}>
              <span style={{ color: '#204a87' }}>{`"${key}"`}</span>:
              {typeof value === 'string' ? (
                <span style={{ color: '#4e9a06' }}>{`"${value}"`}</span>
              ) : typeof value === 'number' ? (
                <span style={{ color: '#4e9a06' }}> {value}</span>
              ) : (
                <span>{renderJson(value, 0)}</span>
              )}
              {index < Object.entries(data).length - 1 && ','}
            </div>
          ))}
          {'}'}
        </div>
      );
    }

    return (
      <span style={indent} className="font-mono">
        {typeof data === 'string' ? (
          <span className="text-green-600">{`"${data}"`}</span>
        ) : typeof data === 'number' ? (
          <span className="text-purple-600">{data}</span>
        ) : (
          String(data)
        )}
      </span>
    );
  };

  return (
    <div className="bg-white p-2" style={{ overflow: 'scroll' }}>
      {renderJson(data)}
    </div>
  );
};

JsonPreview.propTypes = {
  data: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
    PropTypes.null
  ]).isRequired
};

export default JsonPreview;
